import React, { PropsWithChildren } from 'react';

/**
 * The two pieces an assistant answer is sectioned with (Figma 21746:18244): a divider between sections
 * and a bold section title. Shared by the markdown body — where `###` headings become titles — and by
 * the sections the bubble adds from structured data (related guides, clarification choices), so both
 * look the same.
 */
export const AssistantDivider: React.FC = () => <hr className="my-0 w-full border-0 border-t border-solid border-content-tertiary" />;

export const AssistantSectionTitle: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="py-2 text-sm font-bold leading-3 text-content-primary">{children}</div>
);
